import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.inlineSmall
props.inline
props.s
props.xs
props.xxs
props.xxxs
props.extraClass
*/

const UniSpinnerClassic = (props) => {
  /*
  let inlineSmall = false;
  if (props.inlineSmall === true) {
    inlineSmall = true;
  }
  */
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }
  return (
    <div className={"unicompo-spinner-classic" + (props.inlineSmall === true ? " unicompo-spinner-classic--inline-small" : "") + (props.inline === true ? " unicompo-spinner-classic--inline" : "") + (props.s === true ? " unicompo-spinner-classic--s" : "") + (props.xs === true ? " unicompo-spinner-classic--xs" : "") + (props.xxs === true ? " unicompo-spinner-classic--xxs" : "") + (props.xxxs === true ? " unicompo-spinner-classic--xxxs" : "") + extraClass}>
      <div className="unicompo-spinner-classic__rotating-fig"></div>
    </div>
  );
};

export default UniSpinnerClassic;